import { ActionsUnion, Action, createAction } from '../../Utils/actionHelper';
import { IDownloadFilesRequest, IProgressDownloading } from '../../Data/interfaces/Obra/IDownloadFilesRequest';
import { ICurrentUserPrivileges } from 'Data/interfaces/User/ICurrentUserPrivileges';

export enum ListagemArquivosActionKeys {
  DOWNLOAD_FILES_REQUEST = 'DOWNLOAD_FILES_REQUEST',
  DOWNLOAD_FILES_SUCCESS = 'DOWNLOAD_FILES_SUCCESS',
  DOWNLOAD_FILES_FAILED = 'DOWNLOAD_FILES_FAILED',
  PROGRESS_DOWNLOAD = 'PROGRESS_DOWNLOAD',

  SET_EDIT_FORM_INDEX = 'SET_EDIT_FORM_INDEX',

  SET_SHOW_EDIT_TABLE = 'SET_SHOW_EDIT_TABLE',

  SET_SHOW_PLOT_REQUEST_TABLE = 'SET_SHOW_PLOT_REQUEST_TABLE',

  SET_SHOW_MODAL_DELETE_FILES = 'SET_SHOW_MODAL_DELETE_FILES',

  SET_SHOW_MODAL_CREATE_FOLDER = 'SET_SHOW_MODAL_CREATE_FOLDER',

  SET_SHOW_MODAL_INFO_FILES = 'SET_SHOW_MODAL_INFO_FILES',

  SET_SHOW_MODAL_DOWNLOAD_MULTIPLE_FILES = 'SET_SHOW_MODAL_DOWNLOAD_MULTIPLE_FILES',

  TOOGLE_SHOW_FILTER_TIPO = 'TOOGLE_SHOW_FILTER_TIPO',
  TOOGLE_SHOW_FILTER_VISUALIZATION = 'TOOGLE_SHOW_FILTER_VISUALIZATION',
  TOOGLE_SHOW_FILTER_STATUS = 'TOOGLE_SHOW_FILTER_STATUS',
  TOOGLE_SHOW_FILTER_MODIFICADO = 'TOOGLE_SHOW_FILTER_MODIFICADO',
  TOOGLE_SHOW_FILTER_VERSIONS = 'TOOGLE_SHOW_FILTER_VERSIONS',
  TOOGLE_SHOW_FILTER_MODIFICADO_DATA = 'TOOGLE_SHOW_FILTER_MODIFICADO_DATA',
  TOOGLE_SHOW_FILTER_MODIFICADO_USERS = 'TOOGLE_SHOW_FILTER_MODIFICADO_USERS',

  SET_SELECTED_EDIT_ROW_KEYS = 'SET_SELECTED_EDIT_ROW_KEYS',

  SET_SELECTED_PLOT_REQUEST_ROW_KEYS = 'SET_SELECTED_PLOT_REQUEST_ROW_KEYS',

  CURRENT_USER_PRIVILEGES = 'CURRENT_USER_PRIVILEGES',

  TOOGLE_SHOW_INFO_CARD = 'TOOGLE_SHOW_INFO_CARD',
}

export const ListagemArquivosActions = {
  downloadFiles: (request: IDownloadFilesRequest): DownloadFilesAction =>
    createAction(ListagemArquivosActionKeys.DOWNLOAD_FILES_REQUEST, request),
  downloadFilesSuccess: (response: any): DownloadFilesSuccessAction =>
    createAction(ListagemArquivosActionKeys.DOWNLOAD_FILES_SUCCESS, response),
  downloadFilesFailure: (err: string): DownloadFilesFailureAction =>
    createAction(ListagemArquivosActionKeys.DOWNLOAD_FILES_FAILED, err),
  progressDownload: (request: IProgressDownloading): ProgressDownloadAction =>
    createAction(ListagemArquivosActionKeys.PROGRESS_DOWNLOAD, request),

  setEditFormIndex: (index: number): SetEditFormIndexAction =>
    createAction(ListagemArquivosActionKeys.SET_EDIT_FORM_INDEX, index),

  setShowEditTable: (visible: boolean): SetShowEditTableAction =>
    createAction(ListagemArquivosActionKeys.SET_SHOW_EDIT_TABLE, visible),

  setShowPlotRequestTable: (visible: boolean): SetShowPlotRequestTableAction =>
    createAction(ListagemArquivosActionKeys.SET_SHOW_PLOT_REQUEST_TABLE, visible),

  setShowModalDeleteFiles: (visible: boolean): SetShowModalDeleteFilesAction =>
    createAction(ListagemArquivosActionKeys.SET_SHOW_MODAL_DELETE_FILES, visible),

  setShowModalCreateFolder: (visible: boolean): SetShowModalCreateFolderAction =>
    createAction(ListagemArquivosActionKeys.SET_SHOW_MODAL_CREATE_FOLDER, visible),

  setShowModalInfoFiles: (visible: boolean): SetShowModalInfoFilesAction =>
    createAction(ListagemArquivosActionKeys.SET_SHOW_MODAL_INFO_FILES, visible),

  setSelectedEditRowKeys: (keys: string[]): SelectedEditRowKeysAction =>
    createAction(ListagemArquivosActionKeys.SET_SELECTED_EDIT_ROW_KEYS, keys),

  setSelectedPlotRequestRowKeys: (keys: number[]): SelectedPlotRequestRowKeysAction =>
    createAction(ListagemArquivosActionKeys.SET_SELECTED_PLOT_REQUEST_ROW_KEYS, keys),

  setShowFilterTipo: (visible: boolean): ToogleShowFilterTipoAction =>
    createAction(ListagemArquivosActionKeys.TOOGLE_SHOW_FILTER_TIPO, visible),

  setShowFilterVisualization: (visible: boolean): ToogleShowFilterVisualizationAction =>
    createAction(ListagemArquivosActionKeys.TOOGLE_SHOW_FILTER_VISUALIZATION, visible),

  setShowFilterStatus: (visible: boolean): ToogleShowFilterStatusAction =>
    createAction(ListagemArquivosActionKeys.TOOGLE_SHOW_FILTER_STATUS, visible),

  setShowVersions: (visible: boolean): ToogleShowFilterVersionsAction =>
    createAction(ListagemArquivosActionKeys.TOOGLE_SHOW_FILTER_VERSIONS, visible),

  setShowModificado: (
    visible: boolean,
    dropdownVisible: boolean,
  ): ToogleShowFilterModificadoAction =>
    createAction(ListagemArquivosActionKeys.TOOGLE_SHOW_FILTER_MODIFICADO, {
      show: visible,
      showDropdown: dropdownVisible,
    }),
  setShowModificadoData: (visible: boolean): ToogleShowFilterModificadoDataAction =>
    createAction(ListagemArquivosActionKeys.TOOGLE_SHOW_FILTER_MODIFICADO_DATA, visible),
  setShowModificadoUsers: (visible: boolean): ToogleShowFilterModificadoUsersAction =>
    createAction(ListagemArquivosActionKeys.TOOGLE_SHOW_FILTER_MODIFICADO_USERS, visible),

  setShowModalDownloadMultipleFiles: (
    value: { isVisible: boolean, hasFolder?: boolean },
  ): SetShowModalDownloadMultipleFiles =>
    createAction(ListagemArquivosActionKeys.SET_SHOW_MODAL_DOWNLOAD_MULTIPLE_FILES, value),

  currentUserPrivileges: (value: ICurrentUserPrivileges): CurrentUserPrivilegesAction =>
    createAction(ListagemArquivosActionKeys.CURRENT_USER_PRIVILEGES, value),

  toggleShowInfoCard: (value: boolean): ToggleShowInfoCardAction =>
    createAction(ListagemArquivosActionKeys.TOOGLE_SHOW_INFO_CARD, value),
};

export type ListagemArquivosActionUnion = ActionsUnion<typeof ListagemArquivosActions>;

export type DownloadFilesAction = Action<
  ListagemArquivosActionKeys.DOWNLOAD_FILES_REQUEST,
  IDownloadFilesRequest
>;
export type DownloadFilesSuccessAction = Action<
  ListagemArquivosActionKeys.DOWNLOAD_FILES_SUCCESS,
  any
>;
export type DownloadFilesFailureAction = Action<
  ListagemArquivosActionKeys.DOWNLOAD_FILES_FAILED,
  string
>;

export type ProgressDownloadAction = Action<
  ListagemArquivosActionKeys.PROGRESS_DOWNLOAD,
  IProgressDownloading
>;

export type SetEditFormIndexAction = Action<
  ListagemArquivosActionKeys.SET_EDIT_FORM_INDEX,
  number
>;

export type SetShowEditTableAction = Action<
  ListagemArquivosActionKeys.SET_SHOW_EDIT_TABLE,
  boolean
>;

export type SetShowPlotRequestTableAction = Action<
  ListagemArquivosActionKeys.SET_SHOW_PLOT_REQUEST_TABLE,
  boolean
>;

export type SetShowModalDeleteFilesAction = Action<
  ListagemArquivosActionKeys.SET_SHOW_MODAL_DELETE_FILES,
  boolean
>;

export type SetShowModalCreateFolderAction = Action<
  ListagemArquivosActionKeys.SET_SHOW_MODAL_CREATE_FOLDER,
  boolean
>;

export type SetShowModalInfoFilesAction = Action<
  ListagemArquivosActionKeys.SET_SHOW_MODAL_INFO_FILES,
  boolean
>;

export type SetShowModalDownloadMultipleFiles = Action<
  ListagemArquivosActionKeys.SET_SHOW_MODAL_DOWNLOAD_MULTIPLE_FILES,
  { isVisible: boolean, hasFolder?: boolean }
>;

export type SelectedEditRowKeysAction = Action<
  ListagemArquivosActionKeys.SET_SELECTED_EDIT_ROW_KEYS,
  string[]
>;

export type SelectedPlotRequestRowKeysAction = Action<
  ListagemArquivosActionKeys.SET_SELECTED_PLOT_REQUEST_ROW_KEYS,
  number[]
>;

export type ToogleShowFilterTipoAction = Action<
  ListagemArquivosActionKeys.TOOGLE_SHOW_FILTER_TIPO,
  boolean
>;

export type ToogleShowFilterVisualizationAction = Action<
  ListagemArquivosActionKeys.TOOGLE_SHOW_FILTER_VISUALIZATION,
  boolean
>;

export type ToogleShowFilterStatusAction = Action<
  ListagemArquivosActionKeys.TOOGLE_SHOW_FILTER_STATUS,
  boolean
>;

export type ToogleShowFilterVersionsAction = Action<
  ListagemArquivosActionKeys.TOOGLE_SHOW_FILTER_VERSIONS,
  boolean
>;

export type ToogleShowFilterModificadoAction = Action<
  ListagemArquivosActionKeys.TOOGLE_SHOW_FILTER_MODIFICADO,
  { showDropdown: boolean; show: boolean }
>;
export type ToogleShowFilterModificadoDataAction = Action<
  ListagemArquivosActionKeys.TOOGLE_SHOW_FILTER_MODIFICADO_DATA,
  boolean
>;
export type ToogleShowFilterModificadoUsersAction = Action<
  ListagemArquivosActionKeys.TOOGLE_SHOW_FILTER_MODIFICADO_USERS,
  boolean
>;

export type CurrentUserPrivilegesAction =
  Action<ListagemArquivosActionKeys.CURRENT_USER_PRIVILEGES, ICurrentUserPrivileges>;

export type ToggleShowInfoCardAction = Action<
  ListagemArquivosActionKeys.TOOGLE_SHOW_INFO_CARD,
  boolean
>;
